import { render, staticRenderFns } from "./MembersEdit.vue?vue&type=template&id=28cfbcd1"
import script from "./MembersEdit.vue?vue&type=script&lang=js"
export * from "./MembersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports